export var BOMAutoCreateType;
(function (BOMAutoCreateType) {
    BOMAutoCreateType[BOMAutoCreateType["NONE"] = 1] = "NONE";
    BOMAutoCreateType[BOMAutoCreateType["WORK_ORDER"] = 2] = "WORK_ORDER";
})(BOMAutoCreateType || (BOMAutoCreateType = {}));
//# sourceMappingURL=bom-auto-create-type.js.map